import React, { useState, useEffect } from "react";
import { Tab } from "@mui/material";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import "./selectCategoryTab.css";

const SelectCategoryTab = ({ categoryList, fetchServices, setServiceList, setCategoryImport}) => {
  
  const [value, setValue] = useState(
    Number(sessionStorage.getItem("selectedTabIndex")) || 0
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
    sessionStorage.setItem("selectedTabIndex", newValue);
  };

  useEffect(() => {
    if (categoryList.length > 0) {
      const selectedCategory = categoryList[value];
      if (selectedCategory?.id) {
        setServiceList([]);
        fetchServices(selectedCategory?.id);
        setCategoryImport(selectedCategory?.id);
      } else {
        fetchServices(null);
      }
    }
  }, [value, categoryList, fetchServices, setServiceList, setCategoryImport]);

  return (
    <>
      <div className="select-category">Select Category</div>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        aria-label="visible arrows tabs example"
        sx={{
          [`& .${tabsClasses.scrollButtons}`]: {
            "&.Mui-disabled": { opacity: 0.3 },
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "#ff4d4d",
          },
        }}
      >
        {categoryList.map((category, index) => (
          <Tab
            key={index}
            label={
              <span style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={`${category.icon}`}
                  alt={category.category_name}
                  style={{ width: 24, height: 24, marginRight: 8 }}
                />
                <span>{category.category_name}</span>
              </span>
            }
            sx={{
              textTransform: "none",
              color: value === index ? "white" : "black",
              backgroundColor: value === index ? "#ff4d4d" : "transparent",
              "&.Mui-selected": {
                color: "white",
                backgroundColor: "#ff4d4d",
                fontSize: "16px",
                fontWeight: "500",
              },
              borderRadius: "8px",
              padding: "6px 12px",
            }}
          />
        ))}
      </Tabs>
    </>
  );
};

export default SelectCategoryTab;
